import React, {
  useState,
  useEffect,
  PureComponent,
  useRef,
  useMemo,
} from "react";
import StyledTable from "../../../Reusablecomponents/UITable/UITable";
import upload from "../../../assets/images/upload.svg";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import styled from "styled-components";
import {
  Tooltip,
  Badge,
  Avatar,
  Form,
  Select,
  DatePicker,
  Space,
  Row,
  Col,
  Spin,
  Tag,
  message,
} from "antd";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import UIModal from "../../../Reusablecomponents/UIModal";
import GridBuilder from "../../../UIBuilderEngine/GridBuilder";
import { useSelector } from "react-redux";
import { BreakTypeEnum, TripTypeEnum } from "../../../Common/constant";
import { CALL_API } from "../../../Common/api";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
const Customstyle = styled.div`
  .head {
    color: #5f6d8c;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
  .badg {
    padding: 5px;
  }
  .badg .ant-badge-count {
    font-size: 12px; /* Adjust the count number size */
    height: 16px; /* Decrease the outer circle height */
    min-width: 16px; /* Decrease the outer circle width */
    line-height: 16px; /* Center the count text vertically */
  }
  .filterstyle {
    height: 25px;
    width: 25px;
  }
  .plc .ant-select-selection-placeholder {
    color: black !important; /* Set placeholder text color to black */
  }

  .plc .ant-select-arrow {
    color: black; /* Set dropdown arrow color to black */
  }
`;
function Tripbreakreport() {
  const csvLinkEl = useRef();
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("TRBRPT", "EX"),
    [reduxPermissions],
  );
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal, bVal;

      // Handle computed field: breakItems
      if (tableSort.field === "breakItems") {
        aVal = getBreakTypeText(a);
        bVal = getBreakTypeText(b);
      } else {
        aVal = a[tableSort.field];
        bVal = b[tableSort.field];
      }

      // Handle numeric fields
      if (["TRIPTYPE"].includes(tableSort.field)) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle duration calculation for BREAKDURATION
      if (tableSort.field === "BREAKDURATION") {
        aVal = getBreakDurationMinutes(a);
        bVal = getBreakDurationMinutes(b);
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const getBreakDurationMinutes = (record) => {
    const { BREAKSTART, BREAKSTOP } = record;
    if (!BREAKSTART || !BREAKSTOP) return -1; // keeps "-" at top

    const [sh, sm] = BREAKSTART.split(":").map(Number);
    const [eh, em] = BREAKSTOP.split(":").map(Number);

    let start = sh * 60 + sm;
    let end = eh * 60 + em;

    let diff = end - start;
    if (diff < 0) diff += 24 * 60;

    return diff;
  };

  const getBreakTypeText = (record) => {
    const types = [];
    if (record.MEALS) types.push("MEALS");
    if (record.REST) types.push("REST");
    if (record.OTHER) types.push("OTHER");
    if (record.BREAKDOWN) types.push("BREAKDOWN");
    return types.length ? types.join(", ") : "";
  };

  const formatBreakDuration = (mins) => {
    const totalMinutes = Number(mins);

    if (!totalMinutes || totalMinutes < 0) return "00:00";

    const days = Math.floor(totalMinutes / (24 * 60));
    const remainingMinutes = totalMinutes % (24 * 60);

    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(minutes).padStart(2, "0")}`;
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  const TripbreakColumn = [
    {
      title: "Trip Code",
      dataIndex: "CODE",
      key: "CODE",
      sorter: (a, b) => (a.CODE || "").localeCompare(b.CODE || ""),
      sortOrder: tableSort.field === "CODE" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "TRIPTYPE",
      key: "TRIPTYPE",
      sorter: (a, b) => (a.TRIPTYPE || 0) - (b.TRIPTYPE || 0),
      sortOrder: tableSort.field === "TRIPTYPE" ? tableSort.order : null,
      render: (value) => {
        const tripType = TripTypeEnum.find((type) => type.value === value);
        return tripType ? tripType.name : "";
      },
    },
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      sorter: (a, b) => (a.REGNO || "").localeCompare(b.REGNO || ""),
      sortOrder: tableSort.field === "REGNO" ? tableSort.order : null,
    },
    {
      title: "Driver Name",
      dataIndex: "DriverName",
      key: "DriverName",
      sorter: (a, b) => (a.DriverName || "").localeCompare(b.DriverName || ""),
      sortOrder: tableSort.field === "DriverName" ? tableSort.order : null,
    },
    {
      title: "Break Type",
      dataIndex: "breakItems",
      key: "breakItems",
      sorter: (a, b) => getBreakTypeText(a).localeCompare(getBreakTypeText(b)),
      sortOrder: tableSort.field === "breakItems" ? tableSort.order : null,
      render: (_, record) => {
        const text = getBreakTypeText(record);
        return text || "OTHERS";
      },
    },
    {
      title: "Break Date",
      dataIndex: "BREAKDATE",
      key: "BREAKDATE",
      sorter: (a, b) => (a.BREAKDATE || "").localeCompare(b.BREAKDATE || ""),
      sortOrder: tableSort.field === "BREAKDATE" ? tableSort.order : null,
    },
    {
      title: "Break Start",
      dataIndex: "BREAKSTART",
      key: "BREAKSTART",
      sorter: (a, b) => (a.BREAKSTART || "").localeCompare(b.BREAKSTART || ""),
      sortOrder: tableSort.field === "BREAKSTART" ? tableSort.order : null,
    },
    {
      title: "Break End",
      dataIndex: "BREAKSTOP",
      key: "BREAKSTOP",
      sorter: (a, b) => (a.BREAKSTOP || "").localeCompare(b.BREAKSTOP || ""),
      sortOrder: tableSort.field === "BREAKSTOP" ? tableSort.order : null,
    },
    {
      title: "Break Duration",
      dataIndex: "BREAKDURATION",
      key: "BREAKDURATION",
      sorter: (a, b) => getBreakDurationMinutes(a) - getBreakDurationMinutes(b),
      sortOrder: tableSort.field === "BREAKDURATION" ? tableSort.order : null,
      render: (_, record) => {
        const mins = getBreakDurationMinutes(record);
        return formatBreakDuration(mins);
      },
    },
  ];

  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const handleTooltipVisibleChange = (visible) => {
    setVisible(visible);

    if (visible) {
      setTimeout(() => {
        const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
        tooltipArrows.forEach((arrow) => {
          arrow.style.display = "none"; // Hide the arrow
        });
      }, 0);
    }
  };

  const handleTooltipVisibleChange1 = (visible) => {
    setVisible1(visible);

    if (visible) {
      setTimeout(() => {
        const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
        tooltipArrows.forEach((arrow) => {
          arrow.style.display = "none"; // Hide the arrow
        });
      }, 0);
    }
  };
  //api call  for trip bresak report
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [selectedDate, setSelectedDate] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [tripBreakTableData, setTripBreakTableData] = useState([]);
  const [duration, setDuration] = useState("current_month");
  const [loading, setLoading] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [formData, SetformData] = useState({});

  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `tripbreak/get_tripbreak_Table?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate?.[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
          "YYYY-MM-DD",
        )}`,
        {
          vehId: formData?.Vehicle || 0,
          Cust: formData?.Consignor || 0,
          Shipper: formData?.Transporter || 0,
          BreakType: formData?.BreakType || 0,
          Triptype: formData?.TripType || 0,
          Driver: formData?.Driver || 0,
        },
      );
      if (data?.TripBreakTable?.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.TripBreakTable);

        const csvData = (sortedData || []).map((item) => {
          const breakTypes = [];
          if (item.MEALS && item.MEALS !== 0) breakTypes.push(`MEALS`);
          if (item.REST && item.REST !== 0) breakTypes.push(`REST`);
          if (item.OTHER && item.OTHER !== 0) breakTypes.push(`OTHER`);
          if (item.BREAKDOWN && item.BREAKDOWN !== 0)
            breakTypes.push(`BREAKDOWN`);

          return {
            "Trip Code": item.CODE || "-",
            "Trip Type": item.TRIPTYPE || "-",
            Vehicle: item.REGNO || "-",
            "Driver Name": item.DriverName || "-",
            "Break Type":
              breakTypes.length > 0 ? breakTypes.join(", ") : "OTHERS",
            "Break Date": item.BREAKDATE || "-",
            "Break Start": item.BREAKSTART || "-",
            "Break End": item.BREAKSTOP || "-",
            "Break Duration":
              formatBreakDuration(
                getBreakDurationMinutes?.(item) ?? item.BREAKDURATION,
              ) || "00:00",
          };
        });

        setCSVList(csvData && csvData.length > 0 ? csvData : []);

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
      message.error(
        "Failed to prepare CSV. " + (error?.response?.data?.message || ""),
      );
    } finally {
      setCSVLoader(false);
    }
  };

  //calculate total time for chart
  //   const [totalBreakTime, setTotalBreakTime] = useState("00:00");

  // const calculateTotalTime = (data) => {
  //    const totalMinutes = data.reduce((sum, item) => sum + (item.Val || 0), 0);
  //   const hours = Math.floor(totalMinutes / 60);
  //   const minutes = totalMinutes % 60;
  //   return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  // };

  const fetchTripBreakchart = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `tripbreak/get_tripbreak_chart?MCID=${userInfo?.MCID}&startDate=${dayjs(
        selectedDate?.[0],
      ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
        "YYYY-MM-DD",
      )}`,
      {
        vehId: formData?.Vehicle || 0,
        Cust: formData?.Consignor || 0,
        Shipper: formData?.Transporter || 0,
        BreakType: formData?.BreakType || 0,
        Triptype: formData?.TripType || 0,
        Driver: formData?.Driver || 0,
      },
    );

    setChartData(data.TripBreakChart || []);
    // const total = calculateTotalTime(data.TripBreakChart || []);
    // setTotalBreakTime(total)
    setLoading(false);
  };
  const fetchTripBreakTable = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `tripbreak/get_tripbreak_Table?MCID=${userInfo?.MCID}&startDate=${dayjs(
        selectedDate?.[0],
      ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
        "YYYY-MM-DD",
      )}`,
      {
        vehId: formData?.Vehicle || 0,
        Cust: formData?.Consignor || 0,
        Shipper: formData?.Transporter || 0,
        BreakType: formData?.BreakType || 0,
        Triptype: formData?.TripType || 0,
        Driver: formData?.Driver || 0,
      },
    );
    setTripBreakTableData(data.TripBreakTable || []);
    setLoading(false);
  };
  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(formData).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };
  useEffect(() => {
    fetchTripBreakchart();
    fetchTripBreakTable();
    getFilterCount();
  }, [formData, selectedDate]);
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const COLORS = ["#00C3A3", "#0176EC", "#C3006B", "#FF9058"];
  const breakTypeMap = [
    { name: "Meals", value: 1 },
    { name: "Rest", value: 2 },
    { name: "Break down", value: 3 },
    { name: "Others", value: 0 },
  ];
  // const pieChartData = [
  //   { name: "Others", value: 400 },
  //   { name: "Rest", value: 800 },
  //   { name: "Break down", value: 300 },
  //   { name: "Meals", value: 300 },
  // ];
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    percent,
    outerRadius,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.4; // Adjust the radius for label positioning
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const ishrline = Math.cos(-midAngle * RADIAN) > 0;
    const lineLength = ishrline ? 100 : -100;
    const textOffset = ishrline ? 20 : -20;
    const color = COLORS[index % COLORS.length];
    const squareSize = 12;

    // Mock time value for the label
    const timeValue = chartData[index].time || "00:60"; // Adjust this key if needed

    return (
      <>
        {/* Anchor line */}
        <line
          x1={x}
          y1={y}
          x2={x + lineLength}
          y2={y}
          stroke="#ccc"
          strokeWidth={1}
        />
        <circle
          cx={x + lineLength + (ishrline ? -squareSize / 2 : 0)}
          cy={y}
          r={squareSize / 2}
          fill={color}
        />
        <text
          x={x + lineLength + textOffset}
          y={y}
          fill="#5F6D8C"
          textAnchor={ishrline ? "start" : "end"}
          dominantBaseline="central"
          fontSize={12}
        >
          {` ${
            breakTypeMap?.find((itme) => itme?.value === chartData[index].Data)
              ?.name
          } ${timeValue} (${(percent * 100).toFixed(2)}%)`}
        </text>
      </>
    );
  };
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [form] = Form.useForm();
  const handleclickfilter = () => {
    SetOpenmodal(true);
  };
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );

  const [openmodal, SetOpenmodal] = useState(false);

  const handleChange = (e) => {
    const { value, name } = e.target;
    SetformData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const addeditform = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              name: "Vehicle",
              label: "Vehicle",
              type: "selectwithvalue",
              placeholder: "KA12334",
              value: formData.Kpiname,
              onChange: handleChange,
              options: vehicleList?.map((item) => ({
                label: item.REGNO,
                value: item.VEHID,
              })),

              style: "",
              // validationRules: [
              //   {
              //     message: "Kpiname must be a valid ",
              //   },
              // ],
            },
            {
              name: "TripType",
              label: "Trip Type",
              type: "selectwithvalue",
              onChange: handleChange,
              options: TripTypeEnum?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
            {
              name: "Driver",
              label: "Driver",
              type: "selectwithvalue",
              onChange: handleChange,
              options: driverList?.map((item) => ({
                label: item.FULLNM,
                value: item.UID,
              })),
            },
            {
              name: "Consignor",
              label: "Consignor",
              type: "selectwithvalue",
              value: formData.consignor,
              onChange: handleChange,
              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
            },
          ],
          [
            {
              name: "Transporter",
              label: "Transporter",
              type: "selectwithvalue",
              onChange: handleChange,
              value: formData.transporter,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
            },

            {
              name: "BreakType",
              label: "Break Type",
              type: "selectwithvalue",
              value: formData.breakType,
              onChange: handleChange,
              options: BreakTypeEnum?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
            {},
            {},
          ],
        ],
      },
    ],
  };
  const handleSubmit = () => {};

  const handleSelectChange = (field, value) => {
    SetformData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  return (
    <>
      <Customstyle>
        <div id="Export Chart">
          <div className="total">
            <div className="head">Chart View</div>
            <div className="Custom">
              <div className="dropstyle">
                {" "}
                <Form.Item
                  label=""
                  name="dropdown"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    placeholder="Custom Range"
                    className="plc"
                    style={{ width: "240px" }}
                    defaultValue={duration}
                    onChange={(values) => {
                      setDuration(values);
                    }}
                  >
                    {Duration.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="dropstyle1">
                <Space direction="vertical" size={12}>
                  <RangePicker
                    value={selectedDate}
                    onChange={(date, dateString) => setSelectedDate(date)}
                  />
                </Space>
              </div>
              <div>
                <Tooltip
                  title={!exportAllowed ? "No permission" : "Export"}
                  placement="bottom"
                  visible={visible1}
                  onVisibleChange={handleTooltipVisibleChange1}
                  overlayInnerStyle={{
                    backgroundColor: "transparent",
                    color: "#5f6d8c",
                    boxShadow: "none",
                  }}
                >
                  <Spin spinning={CSVLoader}>
                    <img
                      src={upload}
                      alt="Upload Icon"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      className="hover-image"
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Export Chart", "Trip break chart");
                      }}
                    />
                  </Spin>
                </Tooltip>
              </div>
              <div>
                <Badge
                  count={filterCount}
                  className="badg"
                  onClick={handleclickfilter}
                >
                  <Avatar
                    shape="circle"
                    size="medium"
                    src={filtericon}
                    className="filterstyle"
                  />
                </Badge>
              </div>
            </div>
          </div>

          <UIModal
            header={`Filter (${filterCount})`}
            open={openmodal}
            onClose={() => SetOpenmodal(false)}
            footer={[]}
            size="1250px"
            width={1000}
            closeButton={false}
          >
            <Row>
              <Col xl={24} sm={24}>
                <GridBuilder
                  handleChange={handleChange}
                  formSubmit={handleSubmit}
                  formStructureJson={addeditform}
                  initialValues={formData}
                  form={form}
                  handleSelectChange={handleSelectChange}
                />
              </Col>
            </Row>{" "}
          </UIModal>

          <div
            id="Export_Chart"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "white",
            }}
          >
            <Row>
              <ResponsiveContainer width="100%" height={300}>
                <Spin spinning={loading}>
                  <PieChart width={1000} height={278}>
                    <Pie
                      dataKey="Val"
                      startAngle={180}
                      endAngle={0}
                      data={chartData}
                      cx="50%"
                      cy="80%"
                      outerRadius={150}
                      innerRadius={100}
                      label={renderCustomizedLabel}
                    >
                      {chartData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <text
                      x="50%" // Center the text horizontally
                      y="70%" // Center the text vertically
                      textAnchor="middle" // Align text to the middle
                      dominantBaseline="middle" // Center the text vertically
                      fontSize={16} // Adjust font size as needed
                      fill="#5F6D8C"
                    >
                      <tspan x="50%" dy="-0.6em">
                        Total Breaks
                      </tspan>
                      <tspan
                        x="50%"
                        dy="1.2em"
                        fontWeight="bold"
                        fill="black"
                        fontSize="22px"
                      >
                        {tripBreakTableData.length}
                      </tspan>
                    </text>
                  </PieChart>
                </Spin>
              </ResponsiveContainer>
            </Row>
          </div>
        </div>
        <div className="total">
          {/* <Spin spinning={loading}> */}
          <div className="head">
            <p>{tripBreakTableData.length} Trip Break Reports</p>
          </div>

          <div className="Custom">
            <Tooltip
              title={!exportAllowed ? "No permission" : "Export"}
              placement="bottom"
              visible={visible1}
              onVisibleChange={handleTooltipVisibleChange1}
              overlayInnerStyle={{
                backgroundColor: "transparent",
                color: "#5f6d8c",
                boxShadow: "none",
              }}
            >
              <Spin spinning={CSVLoader}>
                <img
                  src={upload}
                  alt="Upload Icon"
                  className="hover-image"
                  onClick={() => {
                    if (!exportAllowed) return;
                    prepareCSV();
                  }}
                  style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                />
              </Spin>
              <CSVLink
                data={CSVList && CSVList.length > 0 ? CSVList : []}
                filename={"Trip Break Report.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
            </Tooltip>
          </div>
          {/* </Spin> */}
        </div>
        <br />
        <StyledTable
          dataSource={tripBreakTableData}
          columns={TripbreakColumn}
          pagination={false}
          onChange={(pagination, filters, sorter) => {
            setTableSort({
              field: sorter.field,
              order: sorter.order,
            });
          }}
        />
      </Customstyle>
    </>
  );
}

export default Tripbreakreport;
